module.exports = __webpack_public_path__ + "img/saveMap.8587a603.svg";